
	<div class="modal-card">
		<header class="modal-card-head">
			<p class="modal-card-title">Wybór koloru</p>
			<button
				type="button"
				class="delete"
				aria-label="close"
				@click="$parent.$emit('close')"
			></button>
		</header>
		<section class="modal-card-body">
			<div class="colors">
				<!-- <a :class="[ 'color', { selected: color.hex === selected.hex } ]" v-for="color in colors" :key="color.name" @click.prevent="selected = color"> -->
				<a
					:class="['color', { selected: color.hex === selected.hex }]"
					v-for="color in colors"
					:key="color.name"
					@click.prevent="select(color)"
				>
					<span class="color__preview" :style="getTagStyle(color.hex)"></span>
					<span class="color__name">{{ color.name }}</span>
				</a>
			</div>
			<hr />
			<p>
				Wybrany kolor: <b>{{ selected.name }}</b>
			</p>
		</section>
		<!-- <footer class="modal-card-foot">
      <button type="button" class="button is-success" @click.prevent="$parent.$emit('select', selected)">Wybierz</button>
      <button class="button is-white" type="button" @click="$parent.$emit('close')">Zamknij</button>
    </footer> -->
	</div>
